/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantPriceReportRowData
 */
export interface GoogleMerchantPriceReportRowData {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    offerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    title?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    reportCountryCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    priceMicros?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    priceCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    comparisonPriceMicros?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    comparisonPriceCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantPriceReportRowData
     */
    effectiveness?: string | null;
}

/**
 * Check if a given object implements the GoogleMerchantPriceReportRowData interface.
 */
export function instanceOfGoogleMerchantPriceReportRowData(value: object): value is GoogleMerchantPriceReportRowData {
    return true;
}

export function GoogleMerchantPriceReportRowDataFromJSON(json: any): GoogleMerchantPriceReportRowData {
    return GoogleMerchantPriceReportRowDataFromJSONTyped(json, false);
}

export function GoogleMerchantPriceReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantPriceReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'offerId': json['offerId'] === undefined ? undefined : json['offerId'] === null ? null : json['offerId'],
        'title': json['title'] === undefined ? undefined : json['title'] === null ? null : json['title'],
        'brand': json['brand'] === undefined ? undefined : json['brand'] === null ? null : json['brand'],
        'reportCountryCode': json['reportCountryCode'] === undefined ? undefined : json['reportCountryCode'] === null ? null : json['reportCountryCode'],
        'priceMicros': json['priceMicros'] === undefined ? undefined : json['priceMicros'] === null ? null : json['priceMicros'],
        'priceCurrency': json['priceCurrency'] === undefined ? undefined : json['priceCurrency'] === null ? null : json['priceCurrency'],
        'comparisonPriceMicros': json['comparisonPriceMicros'] === undefined ? undefined : json['comparisonPriceMicros'] === null ? null : json['comparisonPriceMicros'],
        'comparisonPriceCurrency': json['comparisonPriceCurrency'] === undefined ? undefined : json['comparisonPriceCurrency'] === null ? null : json['comparisonPriceCurrency'],
        'effectiveness': json['effectiveness'] === undefined ? undefined : json['effectiveness'] === null ? null : json['effectiveness'],
    };
}

export function GoogleMerchantPriceReportRowDataToJSON(json: any): GoogleMerchantPriceReportRowData {
    return GoogleMerchantPriceReportRowDataToJSONTyped(json, false);
}

export function GoogleMerchantPriceReportRowDataToJSONTyped(value?: GoogleMerchantPriceReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'offerId': value['offerId'],
        'title': value['title'],
        'brand': value['brand'],
        'reportCountryCode': value['reportCountryCode'],
        'priceMicros': value['priceMicros'],
        'priceCurrency': value['priceCurrency'],
        'comparisonPriceMicros': value['comparisonPriceMicros'],
        'comparisonPriceCurrency': value['comparisonPriceCurrency'],
        'effectiveness': value['effectiveness'],
    };
}

